/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

const COOKIE_NAMES = {
  auth_dropin_user_token: 'auth_dropin_user_token',
  auth_dropin_firstname: 'auth_dropin_firstname',
};

const LOCALHOST = [
  'localhost',
  '127.0.0.1',
  '::1'
];

const COOKIE_LIFETIME = 3600;

export { COOKIE_NAMES, COOKIE_LIFETIME, LOCALHOST };
